import type {State} from '../../../../reducers/types'
import type {BuildId} from '../../../../types'

import {getDeliveredArtifactsKey} from './DependenciesTab.utils'

export const getDeliveredArtifacts = (state: State, from: BuildId, to: BuildId) =>
  state.deliveredArtifacts[getDeliveredArtifactsKey(from, to)]
